var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlanValoracion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.743,
    height: 37.274,
    viewBox: "0 0 28.743 37.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M612.177,351.633h12.085a1.609,1.609,0,0,1,1.168,1.817c-.022.335,0,.673,0,1.047h.428c1.007,0,2.014-.012,3.02,0a3.652,3.652,0,0,1,3.737,3.73q.018,13.465,0,26.93a3.652,3.652,0,0,1-3.793,3.745q-10.572,0-21.144,0a3.663,3.663,0,0,1-3.8-3.81q0-13.392,0-26.784a3.667,3.667,0,0,1,3.8-3.813c.983-.008,1.965,0,2.948,0h.441a9.533,9.533,0,0,1,.015-1.335,2.512,2.512,0,0,1,.371-1.025C611.607,351.91,611.93,351.8,612.177,351.633Zm-1.111,5.776c-1.141,0-2.22,0-3.3,0-.728,0-.979.259-.979.991v26.608c0,.742.243.986.981.986h20.966c.7,0,.967-.262.968-.968q0-13.322,0-26.644c0-.7-.267-.969-.965-.972-.995,0-1.99,0-2.985,0-.1,0-.207.015-.328.025,0,.421,0,.809,0,1.2a1.49,1.49,0,0,1-1.637,1.655q-5.551,0-11.1,0a1.475,1.475,0,0,1-1.621-1.629C611.064,358.259,611.066,357.862,611.066,357.409Zm11.439-2.844h-8.493v2.782h8.493Z",
    transform: "translate(-603.878 -351.633)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M625.432,396.327a4.578,4.578,0,0,1,.3-.386q3.085-3.091,6.173-6.18a1.5,1.5,0,0,1,1.611-.471,1.435,1.435,0,0,1,.679,2.277,4.005,4.005,0,0,1-.3.32q-3.628,3.63-7.258,7.258a1.511,1.511,0,0,1-2.453,0q-1.751-1.749-3.5-3.5a1.478,1.478,0,0,1-.4-1.721,1.458,1.458,0,0,1,2.4-.4c.818.794,1.617,1.609,2.421,2.417C625.2,396.038,625.279,396.146,625.432,396.327Z",
    transform: "translate(-612.975 -372.632)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlanValoracion);
export default __webpack_public_path__ + "static/media/ICO-PLAN-VALORACION.a46406611d8bbd220ee53694033b69a4.svg";
export { ForwardRef as ReactComponent };